module.exports = __webpack_public_path__ + "img/icon (16).d23f3fe5.png";